import { getAuthData } from "@common/helpers/auth";
import { LoggedIn } from "../actions/login";
import { UserDidLogin } from "../actions/terminal";
import { store } from "../index/terminalApp";
import { checkFreeBonuses } from "./freeBonuses";

export const makeLogin = (user) => {
  store.dispatch(LoggedIn(user));
  store.dispatch(UserDidLogin({ userId: user.authData.user_id, currency: getAuthData().currency }));
  checkFreeBonuses();
}